// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_typingContainer__7S4dg a {
  color: var(--accent-color3);
  /* font-family: var(--Fira); */
  font-weight: bold;
  text-decoration: none;
  border-bottom: 0.16rem solid var(--accent-color3) ;
}

.styles_typingContainer__7S4dg {
  height: auto !important;
  min-height: 6rem;
}

@media (max-width: 600px) {
  .styles_typingContainer__7S4dg span {
    font-size: 1.5rem !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/public/Home/Typing/styles.module.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,iBAAiB;EACjB,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF","sourcesContent":[".typingContainer a {\n  color: var(--accent-color3);\n  /* font-family: var(--Fira); */\n  font-weight: bold;\n  text-decoration: none;\n  border-bottom: 0.16rem solid var(--accent-color3) ;\n}\n\n.typingContainer {\n  height: auto !important;\n  min-height: 6rem;\n}\n\n@media (max-width: 600px) {\n  .typingContainer span {\n    font-size: 1.5rem !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"typingContainer": `styles_typingContainer__7S4dg`
};
export default ___CSS_LOADER_EXPORT___;
